import { t } from '@lingui/macro';
import { Container, Segment } from './styled';
export function ProgressBar(props) {
    const { progress, currentValue } = props;
    const progressPartition = progress.map(({ value }) => `${value}%`).join(' ');
    return (<Container $progress={progressPartition} role="progressbar" aria-valuenow={currentValue} aria-label={t({
            message: 'Review progress bar',
            comment: 'Plai Drawer - Review progress - title for the review progress for screen reader',
        })}>
      {progress.map(({ appearance }) => (<Segment key={appearance} $appearance={appearance}/>))}
    </Container>);
}
